import { motion } from "framer-motion";

const REASONS = [
  { n: "01", title: "Single-Point Responsibility", desc: "Architecture, structure, MEP and BIM under one roof — no communication gaps, no project friction." },
  { n: "02", title: "Zero-Clash Delivery", desc: "Conflicts are detected and resolved in the model, long before they reach the site." },
  { n: "03", title: "Scalable Technical Capacity", desc: "AI-assisted, computational workflows that scale from a villa to a township without losing precision." },
  { n: "04", title: "Cost & Time Optimization", desc: "Data-rich models linked to schedules, BOQs and cost — decisions made early, savings locked in." },
];

export default function WhyUs() {
  return (
    <section id="why-us" className="py-28 lg:py-36 border-b border-white/10 relative overflow-hidden" data-testid="why-us-section">
      <img src="/star.png" alt="" className="absolute -left-48 top-1/2 -translate-y-1/2 w-[36rem] opacity-[0.06] pointer-events-none select-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 relative">
        <div className="lg:col-span-4">
          <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
            <p className="font-mono-tech text-xs tracking-[0.35em] uppercase text-neutral-500 mb-4">02 / Delivery</p>
            <h2 className="font-heading font-bold uppercase tracking-tighter text-3xl sm:text-4xl lg:text-5xl leading-[1.02]">
              Why<br />Starscape?
            </h2>
          </motion.div>
        </div>
        <div className="lg:col-span-8">
          {REASONS.map((r, i) => (
            <motion.div
              key={r.n}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="group flex gap-6 lg:gap-10 py-8 border-b border-white/10 last:border-b-0 items-baseline"
              data-testid={`why-us-item-${r.n}`}
            >
              <span className="font-mono-tech text-xs tracking-[0.25em] text-neutral-600 group-hover:text-white transition-colors duration-300 shrink-0">
                {r.n}
              </span>
              <div>
                <h3 className="font-heading font-bold uppercase tracking-tight text-lg lg:text-2xl mb-2 group-hover:translate-x-2 transition-transform duration-300">
                  {r.title}
                </h3>
                <p className="text-sm text-neutral-400 font-light leading-relaxed max-w-xl">{r.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
